<template>
    <div>
        <div class="modal fade" id="validarCodigoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Validar Código</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input
                            v-model="codigoAtendimento"
                            placeholder="Leitura do Código de Atendimento..."
                            @onEnter="validateCode" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() {
        return {
            dados: false, 
            codigoAtendimento: "", 
        };
    },

    components: {
        AzInput,
    },

    methods: {
        abrir(marcacao) { 
            this.codigoAtendimento = "";
            this.dados = _.cloneDeep(marcacao);

            $('#validarCodigoModal').modal('show');
        }, 

        validateCode() {
            if ( !this.codigoAtendimento ) {
                this.$toast.add({
                    severity: 'warn',
                    summary: "Chamar",
                    detail: "Realizar a leitura do código do atendimento.",
                    life: 3000
                });
                return;
            }

            let codigo = this.codigoAtendimento.replace(/[^0-9]/g, ''); // Remove non-numeric characters

            if ( codigo != this.dados.id_atendimento ) { 
                this.$toast.add({
                    severity: 'error',
                    summary: "Atenção",
                    detail: "Código de atendimento inválido.",
                    life: 3000
                });
                return;
            }

            this.$toast.add({
                severity: 'success',
                summary: "Atenção",
                detail: "Código de atendimento validado com sucesso.",
                life: 3000
            });

            $('#validarCodigoModal').modal('hide');
        }
    },
};
</script>